/**
 * NoAreaState: what a signed-in user without any area sees instead of mail.
 *
 * The backend returns empty lists and zero counts for such an account; this says why,
 * once, instead of a row of empty tiles and tables.
 */

import { Icon, MapPinOff } from "@norican/icons";
import { Card, EmptyState } from "@norican/react";

import { NO_AREA_MESSAGE } from "@/lib/areas";

export function NoAreaState() {
  return (
    <Card variant="outline" padding="none">
      <Card.Body padding="none">
        <EmptyState
          className="py-12"
          icon={<Icon icon={MapPinOff} size="lg" className="text-fg-subtle" />}
          title="No area assigned"
          description={NO_AREA_MESSAGE}
        />
      </Card.Body>
    </Card>
  );
}
